import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mt',
    fullName: 'Maltese',
    nativeName: 'Malti',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Xi ħaġa tal-għaġeb ġejja",
    landing_subtitle: "ArgVoid huwa studju ta' żvilupp ta' app u logħob. Oqgħod attent, dalwaqt ġejjin affarijiet ġodda!",
    select_language: "Agħżel Lingwa",
    search_placeholder: "Fittex lingwi...",
    terms_title: "Termini tas-Servizz",
    policy_title: "Politika ta' Privatezza",
    cookies_title: "Politika tal-Cookie",
    terms_content: `
        <strong>1. Aċċettazzjoni tat-Termini</strong><br>
        Billi taċċessa ArgVoid, dawn it-Termini tas-Servizz huma aċċettati. Jekk ma jkunx hemm qbil dwar dawn it-termini, is-servizz m'għandux jintuża.<br><br>

        <strong>2. Użu tal-Pjattaforma</strong><br>
        ArgVoid u l-applikazzjonijiet tiegħu huma pprovduti "kif inhu" għal skopijiet informattivi u kreattivi. Is-servizz għandu jintuża biss għal skopijiet legali.<br><br>

        <strong>3. Kondotta Projbita</strong><br>
        L-isfruttament tal-vulnerabbiltajiet tas-sit, l-ispamming, jew it-tentattiv ta' aċċess mhux awtorizzat għall-infrastruttura huma strettament ipprojbiti.<br><br>

        <strong>4. Ċaħda ta' responsabbiltà</strong><br>
        Il-pjattaforma u s-servizzi jistgħu jiġu modifikati fi kwalunkwe ħin mingħajr avviż. L-ebda garanzija ma hija pprovduta fir-rigward tal-uptime jew id-disponibbiltà tas-servizz.
    `,
    policy_content: `
        <strong>1. Ġbir ta' Informazzjoni</strong><br>
        Il-pjattaforma ma teħtieġx awtentikazzjoni tal-utent jew ħolqien ta' kont f'dan il-ħin. L-ebda informazzjoni ta' identifikazzjoni personali (bħal ismijiet jew indirizzi tal-email) ma tinġabar b'mod attiv mingħand il-viżitaturi.<br><br>

        <strong>2. Data tal-Użu</strong><br>
        Jistgħu jinġabru analitiċi bażiċi u anonimizzati biex jifhmu t-traffiku tas-sit u jtejbu l-applikazzjonijiet. Din id-dejta mhijiex marbuta ma' identitajiet ta' utenti individwali.<br><br>

        <strong>3. Servizzi ta' Partijiet Terzi</strong><br>
        Fornituri ta' partijiet terzi jistgħu jiġu utilizzati għal servizzi ta' hosting u analitiċi. Il-prattiki tal-privatezza ta' dawn il-fornituri rispettivi jirregolaw id-dejta anonima pproċessata fuq l-infrastruttura tagħhom.<br><br>

        <strong>4. Sigurtà tad-Dejta</strong><br>
        Miżuri ta' sigurtà raġonevoli huma implimentati biex jipproteġu l-pjattaforma. Madankollu, l-ebda metodu ta' trażmissjoni fuq l-Internet mhu kompletament sigur.<br><br>
    `,
    cookies_content: `
        <strong>1. X'inhuma Cookies u Ħażna Lokali?</strong><br>
        Il-cookies u l-ħażna lokali tal-browser huma fajls żgħar tad-dejta maħżuna fuq it-tagħmir biex tiftakar il-preferenzi tal-konfigurazzjoni matul iż-żjarat.<br><br>

        <strong>2. Użu Għan</strong><br>
        Browser LocalStorage jintuża strettament biex isalva l-issettjar tal-konfigurazzjoni, bħal: <br>
        - Preferenzi lingwistiċi<br>
        - Konfigurazzjoni tal-interface tal-utent (eż., tqassim jew settings tat-tema) <br>
        - Applikazzjoni temporanja cache<br><br>

        <strong>3. Nru Tracking</strong><br>
        Il-cookies u l-ħażna lokali ma jintużawx għal skopijiet ta’ reklamar jew ta’ traċċar ta’ partijiet terzi. Id-dejta kollha maħżuna hija strettament għall-funzjonalità ewlenija tal-pjattaforma.<br><br>

        <strong>4. Kontroll</strong><br>
        Id-dejta tal-browser tista 'titneħħa fi kwalunkwe ħin permezz tas-settings tal-browser, li se jerġa' jissettja kwalunkwe konfigurazzjoni lokali.
    `,
    cookie_consent_text: "Aħna nużaw cookies bażiċi biex niżguraw li l-websajt tiffunzjona b'mod korrett, bħal li nżommu s-sessjoni tiegħek attiva, insalvaw il-preferenza tal-lingwa tiegħek, u konfigurazzjonijiet personalizzati oħra.",
    read_policy: "Aqra l-Politika dwar il-Cookie",
    support_title: "Ikkuntattja l-Appoġġ",
    support_subject_label: "Suġġett",
    support_message_label: "Messaġġ",
    support_submit_button: "Ibgħat Messaġġ",
    support_hint: "Nota: Dan se jiftaħ l-applikazzjoni tiegħek email default biex tibgħat il-messaġġ.",
    support_success_msg: "Niftaħ l-app tal-email tiegħek...",
    support_error_msg: "Naqas milli jibgħat il-messaġġ. Jekk jogħġbok erġa' pprova aktar tard.",
    explorer_title: "Explorer",
    history_title: "Storja",
    animation_title: "Animazzjoni",
    config_title: "Konfigurazzjoni",
    tool_mouse: "Agħżel (Ctrl+M)",
    tool_brush: "Pinzell (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solid/Ċar)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Aġġusta Daqs tal-Pinzell",
    tool_bucket: "Imla (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Dawwar (Ctrl+Shift+R)",
    tool_flip_h: "Aqleb H (Ctrl+Shift+H)",
    tool_flip_v: "Aqleb V (Ctrl+Shift+V)",
    tool_transpose: "Trasponi (Ctrl+Shift+T)",
    label_width: "Wisa'",
    label_height: "Għoli",
    label_frames: "Numru ta' Gwarniċi",
    label_animation: "Stil ta' Animazzjoni",
    label_background_color: "Kulur tal-Isfond",
    label_interval: "Intervall",
    tool_anim_config: "Konfigurazzjoni ta' Animazzjoni",
    label_new_width: "Wisa 'Ġdid",
    label_new_height: "Għoli Ġdid",
    label_apply: "Applika",
    label_colors: "Kuluri",
    label_size: "Daqs",
    label_tolerance: "Tolleranza",
    val_horizontal: "Orizzontali",
    val_vertical: "Vertikali",
    val_sequence: "Sekwenza",
    val_bounce: "Bounce",
    val_random: "Bl-addoċċ",
    val_solid: "Solidu",
    val_clear: "Ċara",
    action_add_sheet: "Folja Ġdida",
    action_import: "Importazzjoni",
    action_export: "Esportazzjoni",
    action_sort_projects: "Issortja",
    sort_date_old: "L-Ewwel Eqdem",
    sort_date_new: "Newest L-Ewwel",
    sort_name_az: "Isem (A-Z)",
    sort_name_za: "Isem (Z-A)",
    action_new_sprite: "Sprite Ġdid",
    action_new_project: "Proġett Ġdid",
    modal_save_all_title: "Issejvja l-Bidliet Kollha",
    modal_save_all_desc: "Agħżel l-assi biex issalva:",
    modal_save_selected: "Ħlief Magħżula",
    action_saved: "Salvat",
    modal_create_sprite_title: "Oħloq Sprite Ġdid",
    modal_create_project_title: "Oħloq Proġett Ġdid",
    modal_add_sheet_title: "Żid Folja Ġdida",
    modal_rename_sheet_title: "Semmi mill-ġdid Sheet",
    modal_rename_sprite_title: "Semmi mill-ġdid Sprite",
    modal_delete_sprite_title: "Ħassar Sprite",
    modal_delete_project_title: "Ħassar Proġett",
    modal_delete_sheet_title: "Ħassar Folja",
    placeholder_sprite_name: "Isem",
    placeholder_project_name: "Isem",
    placeholder_sheet_name: "Isem",
    placeholder_new_name: "Isem Ġdid",
    action_create: "Oħloq",
    action_add: "Żid",
    action_rename: "Semmi mill-ġdid",
    action_duplicate: "Duplikat",
    action_delete: "Ħassar",
    action_cancel: "Ikkanċella",
    confirm_delete_sprite: "Int żgur li trid tħassar dan l-isprite?",
    confirm_delete_project: "Int żgur li trid tħassar dan il-proġett? L-isprites kollha se jitneħħew.",
    confirm_delete_sheet: "Int żgur li trid tħassar din il-folja?",
    err_select_sprite: "Jekk jogħġbok agħżel sprite l-ewwel.",
    err_select_project: "Jekk jogħġbok agħżel proġett l-ewwel.",
    err_name_empty: "L-isem ma jistax ikun vojt.",
    err_sprite_exists: "Sprite b'dak l-isem diġà jeżisti.",
    err_project_exists: "Proġett b'dak l-isem diġà jeżisti.",
    err_no_content: "Ebda kontenut x'tiffranka.",
    err_no_changes: "Ebda bidliet biex issalva.",
    err_delete_last_sheet: "Ma tistax tħassar l-aħħar folja.",
    err_extract_frames: "Ma setax estratt xi frames.",
    err_indexeddb: "Naqas milli ssalva lokalment. Il-browser tiegħek jista' ma jappoġġjax IndexedDB.",
    msg_upload_success: "Ittella' b'suċċess: {0}",
    msg_upload_failed: "Ittella' fallew: {0}",
    msg_save_success: "Ħlief b'suċċess.",
    msg_saving: "Iffrankar...",
    msg_multi_save_result: "{0} assi ffrankati. {1} fallimenti.",
    menu_title: "Menu",
    menu_save: "Ħlief",
    menu_save_all: "Ħlief Kollox",
    menu_support: "Ikkuntattja l-Appoġġ",
    label_local_storage: "Ħażna Lokali",
    label_sign_in: "Idħol",
    modal_export_title: "Esportazzjoni Sprite",
    label_filename: "Isem tal-fajl",
    label_format: "Format",
    action_export_confirm: "Esportazzjoni",
};

export default translations;
